import { render, staticRenderFns } from "./productList.vue?vue&type=template&id=aafcb71c&scoped=true"
import script from "./productList.vue?vue&type=script&lang=js"
export * from "./productList.vue?vue&type=script&lang=js"
import style0 from "./productList.vue?vue&type=style&index=0&id=aafcb71c&prod&lang=scss&scoped=true"
import style1 from "./productList.vue?vue&type=style&index=1&id=aafcb71c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aafcb71c",
  null
  
)

export default component.exports